import { render } from "./existing-documents-table.vue?vue&type=template&id=77024fb1"
import script from "./existing-documents-table.vue?vue&type=script&lang=js"
export * from "./existing-documents-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__